import React from 'react';
import { Box, Typography, useTheme, CircularProgress } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ButtonMAIQ from 'app/components/ReusableUIComponents/LowLevelComponents/buttons/ButtonMAIQ';

interface InitializeMessageContentProps {
  isInitializing: boolean;
  onInitialize: () => void;
}

const InitializeMessageContent = ({
  isInitializing,
  onInitialize,
}: InitializeMessageContentProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        gap: 3,
        textAlign: 'center',
        padding: '48px',
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main + '1A',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <AutoFixHighIcon
          sx={{
            fontSize: 40,
            color: theme.palette.primary.main,
          }}
        />
      </Box>
      <Box sx={{ maxWidth: 480 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            marginBottom: 1,
          }}
        >
          No Message Content Found
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            lineHeight: 1.6,
          }}
        >
          Message content has not been set up for this dealer yet. Initialize to create
          the default operation types for generating AI messages.
        </Typography>
      </Box>
      <ButtonMAIQ
        variant="contained"
        onClick={onInitialize}
        disabled={isInitializing}
        startIcon={isInitializing ? <CircularProgress size={16} color="inherit" /> : undefined}
        sx={{ minWidth: 200, height: 44 }}
      >
        {isInitializing ? 'Initializing...' : 'Initialize Message Content'}
      </ButtonMAIQ>
    </Box>
  );
};

export default InitializeMessageContent;
